import CertificatesMain from './pages'

const router = [
  {
    path: 'certificates',
    name: 'certificates',
    component: CertificatesMain,
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      action: 205
    }
  }
]

export default router
